export default class LicenseServerRoutes {
  // public
  public static readonly Root: string = "/";
  public static readonly SignUp: string = "/signup";
  public static readonly SignIn: string = "/signin";

  // private
  public static readonly Home: string = "/home";
  public static readonly Products: string = "/products";
  public static readonly Customers: string = "/customers";
}
